import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
    selector: '[targetSelectorValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ValidTargetSelectorDirective,
            multi: true,
        },
    ],
    standalone: true,
})
export class ValidTargetSelectorDirective implements Validator {
    validate (control: AbstractControl): ValidationErrors | null {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const value = control.value;
        if (!value) {
            return null;
        }
        try {
            document.querySelector(value);
            return null;
        } catch {
            return { invalidTargetSelector: true };
        }
    }
}
